import styled, { css } from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as ArrowCollapsed } from 'Images/wf_arrow_collapsed.svg';
import { ReactComponent as ArrowExpanded } from 'Images/wf_arrow_expand.svg';
import { ReactComponent as Config } from 'Images/icon-customfields.svg';
import { ReactComponent as Trigger } from 'Images/icon-action-bar-trigger.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  background-color: ${({ theme }) => theme.backgrounds.detailModal};
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 26px;
  padding: 22px 20px;
`;
Wrapper.displayName = 'Wrapper';

export const Header = styled.div`
  display: flex;
  flex: 0 0 44px;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
`;
Header.displayName = 'Header';

export const Title = styled.div`
  display: flex;
  gap: 20px;
`;
Title.displayName = 'Title';

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 220px;
`;
InfoContainer.displayName = 'InfoContainer';

export const Name = styled.div`
  font-size: 14.5px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.detailModalFields};
  user-select: none;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
`;
Name.displayName = 'Name';

export const Category = styled.div`
  font-size: 13.5px;
  font-weight: 400;
  color: ${({ theme }) => theme.text.customAttributeItem};
  user-select: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
`;
Category.displayName = 'Category';

export const Separator = styled.div`
  width: 1px;
  height: 40px;
  margin: 0 12px;
  opacity: 0.19;
  border-right: solid 1px ${colors.greyBlue};
`;
Separator.displayName = 'Separator';

export const Icons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
Icons.displayName = 'Icons';

export const ConfigIcon = styled(Config)`
  margin-right: 13px;
  g, g > path {
    fill: ${({ configured }) => configured ? colors.green1 : colors.red3};
  }
`;

ConfigIcon.displayName = 'ConfigIcon';

export const RunIcon = styled(Trigger)`
`;
RunIcon.displayName = 'RunIcon';

const IconWrapper = css`
  position: absolute;
  top: 17px;
  right: 15px;
`;

export const ExpandedIcon = styled(ArrowExpanded)`
  ${IconWrapper};
  margin: auto 0px auto auto;
  width: 10px;
  color: #90a9c0;
  path {
    fill: #90a9c0;
  }
`;
ExpandedIcon.displayName = 'ExpandedIcon';

export const CollapsedIcon = styled(ArrowCollapsed)`
  ${IconWrapper};
  margin: auto 0px auto auto;
  height: 10px;
  path {
    fill: #90a9c0;
  }
`;
CollapsedIcon.displayName = 'CollapsedIcon';

export const ChildWrapper = styled.div`
`;
ChildWrapper.displayName = 'ChildWrapper';
